<app-webinars-article-video [pageData]="pageData"></app-webinars-article-video>
<app-webinars-article-podcasts [pageData]="pageData"></app-webinars-article-podcasts>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
